const PENDING_MESSAGE_INTENT_STORAGE_KEY = "betterintentions.pendingMessageIntent";
const PENDING_MESSAGE_INTENT_TTL_MS = 24 * 60 * 60 * 1000;

function getSessionStorage() {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

function normalizeIntent(raw) {
  const recipientId = String(raw?.recipientId || "").trim();
  if (!recipientId) return null;

  const createdAtMs = Number(raw?.createdAtMs);
  if (!Number.isFinite(createdAtMs)) return null;

  if (Date.now() - createdAtMs > PENDING_MESSAGE_INTENT_TTL_MS) {
    return null;
  }

  const recipientName = String(raw?.recipientName || "").trim() || "User";
  const userSnapshot =
    raw?.userSnapshot && typeof raw.userSnapshot === "object" ? raw.userSnapshot : null;

  return {
    recipientId,
    recipientName,
    createdAtMs,
    userSnapshot,
  };
}

export function savePendingMessageIntent(intent) {
  const storage = getSessionStorage();
  if (!storage) return;

  const recipientId = String(intent?.recipientId || "").trim();
  if (!recipientId) return;

  const payload = {
    recipientId,
    recipientName: String(intent?.recipientName || "").trim() || "User",
    createdAtMs: Date.now(),
    userSnapshot:
      intent?.userSnapshot && typeof intent.userSnapshot === "object"
        ? intent.userSnapshot
        : null,
  };

  try {
    storage.setItem(PENDING_MESSAGE_INTENT_STORAGE_KEY, JSON.stringify(payload));
  } catch {}
}

export function readPendingMessageIntent() {
  const storage = getSessionStorage();
  if (!storage) return null;

  try {
    const raw = storage.getItem(PENDING_MESSAGE_INTENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const normalized = normalizeIntent(parsed);
    if (!normalized) {
      storage.removeItem(PENDING_MESSAGE_INTENT_STORAGE_KEY);
    }
    return normalized;
  } catch {
    try {
      storage.removeItem(PENDING_MESSAGE_INTENT_STORAGE_KEY);
    } catch {}
    return null;
  }
}

export function clearPendingMessageIntent() {
  const storage = getSessionStorage();
  if (!storage) return;
  try {
    storage.removeItem(PENDING_MESSAGE_INTENT_STORAGE_KEY);
  } catch {}
}

export function consumePendingMessageIntent() {
  const intent = readPendingMessageIntent();
  if (!intent) return null;
  clearPendingMessageIntent();
  return intent;
}
